import useSWR from 'swr';

import axiosInstance from 'apis/axiosInstance';
import { AxiosRequestConfig } from 'axios';

const useAppointmentDetail = (
  appointmentId: string,
  shouldRun = true,
  axiosConfig?: AxiosRequestConfig<any>
) => {
  const { data, error, mutate } = useSWR(
    shouldRun ? `/appointments/${appointmentId}` : null,
    async (url) => {
      const response = await axiosInstance.get(url, axiosConfig);

      return response.data;
    }
  );
  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useAppointmentDetail;
